module.exports = __webpack_public_path__ + "static/media/deactivate.d521c16c.svg";